module.exports = __webpack_public_path__ + "media/cp5.a5ed4a67.mp4";